import styled from 'styled-components';

export const Wrapper = styled.div`
  border: 1px solid rgba(0, 36, 77, 0.05);
  box-shadow: 0 4px 8px rgba(0, 36, 77, 0.08);
  box-sizing: border-box;
  border-radius: 8px;
  padding: 24px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const ContentWrapper = styled.div`
  margin: 8px 0 28px;
`;

export const TitleRow = styled.div`
  display: flex;
  align-items: center;
`;

export const Title = styled.div`
  ${(p) => p.theme.typography.accent};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

export const ClientIDWrapper = styled.div`
  ${(p) => p.theme.typography.body};
  font-size: 11px;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-top: 5px;

  :hover {
    color: ${(p) => p.theme.colors.brand};
  }
`;

export const ClientIDText = styled.span`
  font-weight: bold;
`;
